import Vue from 'vue';
export default new Vue();

const globalData = {
  cardId: '',
  unqid: ''
};

export { globalData };